import { createStore } from "vuex";
import { userStore } from "./user/user.store";
import { portfolioStore } from "./portfolio/portfolio.store";
import { instrumentStore } from "./instrument/instrument.store";
import { orderStore } from "./order/order.store";
import { brokerStore } from "./broker/broker.store";
import { holidayStore } from "./holiday/holiday.store";
import { variationStore } from "./variation/variation.store";
import { settingStore } from "./button/settings.store";
import { commonStore } from "./common/common.store";
import { techDashboardStore } from "./dashboard/techDashboard.store";
import { salesStore } from "./sales/sales.store";
import { authStore } from "./authentication/auth.store";
import { statusDashboard } from "./dashboard/statusDashboard.store";
import { analyticsDashboard } from "./dashboard/analyticsDashboard.store";
import { strategyDashboard } from "./dashboard/strategyDashboard.store";
import { profileStore } from "./profile/profile.store";
import { exchangeStore } from "./exchange/exchange.store";

export default createStore({
    modules: {
        userStore,
        portfolioStore,
        instrumentStore,
        orderStore,
        brokerStore,
        holidayStore,
        variationStore,
        settingStore,
        commonStore,
        techDashboardStore,
        salesStore,
        authStore,
        statusDashboard,
        analyticsDashboard,
        strategyDashboard,
        profileStore,
        exchangeStore
    },
    getters: {}
});
